import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {StorageService} from './auth/storage.service';

@Injectable()
export class HttpClient {

    constructor(private http: Http, private storageService: StorageService) { }

    get(url) {
        let options = new RequestOptions({
            headers: this.storageService.getHeaders()
        });
        return this.http.get(url, options);
    }

    post(url, data) {
        let options = new RequestOptions({
            headers: this.storageService.getHeaders()
        });
        return this.http.post(url, data, options);
    }

    patch(url, data) {
        let options = new RequestOptions({
            headers: this.storageService.getHeaders()
        });
        return this.http.patch(url, data, options);
    }

    delete(url) {
        let options = new RequestOptions({
            headers: this.storageService.getHeaders()
        });
        return this.http.delete(url, options);
    }

}